module.exports = __webpack_public_path__ + "img/posts.b0e14205.png";